<template>
  <banners>
    <div
      class="container-max m-auto"
      :class="{
        'min-h-[94vh] bg-steel-100': !isDesktop,
      }"
    >
      <div class="flex items-center justify-between bg-white px-3 py-8">
        <h1 class="text-lg md:text-4xl">Offers</h1>

        <OffersSortMenu v-if="isDesktop"></OffersSortMenu>
      </div>

      <div class="flex gap-3">
        <OffersTable
          :is-desktop="isDesktop"
          :selectedTab="selectedTab"
          @handle-tab-selection="handleTabSelection"
        ></OffersTable>
      </div>

      <NotificationComponent
        v-show="showOfferNotification"
        title="Offer Updated"
        icon-type="success"
        @close="toggleOfferNotication"
      >
        <div class="text-left">
          <p class="mb-2 text-sm font-normal text-steel-800">
            Your offer was successfully updated.
          </p>
        </div>
      </NotificationComponent>
    </div>
  </banners>
</template>

<script setup>
import { onBeforeMount, ref, computed } from 'vue';
import { useStore } from 'vuex';
// import { useRouter } from 'vue-router';
import { Banners, NotificationComponent } from '@/components';
import { OffersSortMenu, OffersTable } from '@/components/loads';
import { useScreenSize } from '@/composables/useScreenSize';

// const router = useRouter();
const store = useStore();

const { screenSize } = useScreenSize();

const isDesktop = computed(() => screenSize.value === 'desktop');

onBeforeMount(async () => {
  await store.dispatch('loads/getOffers', {});
  await store.dispatch('loads/getExpiredOffers', {});
});

const selectedTab = ref('Active');
const handleTabSelection = (tab) => {
  selectedTab.value = tab;
};

const showOfferNotification = ref(false);
const toggleOfferNotication = () => {
  showOfferNotification.value = !showOfferNotification.value;
};
</script>
